import { useState, useContext, useEffect } from "react";
import { Paper, Select, MenuItem, Button, Divider } from "@mui/material";
// import AppContext from "../../../Contexts/AppContext";
import { DashboardButton } from "./LayerDashboardButton/LayerDashboardButton";

import { useTranslation } from "react-i18next";
import AppContext from "../../../components/Contexts/AppContext";

const LayerFilterSelectorComponent = () => {
  const { t, i18n } = useTranslation("main");
  const { layersGroupsRef } = useContext(AppContext);
  const layersGroups = layersGroupsRef.current;
  // Estado inicial basado en layersGroups
  const [selectedLayerGroup, setSelectedLayerGroup] = useState(null);

  useEffect(() => {
    const firstLayerGroupWithFilter = layersGroups.find(
      (layer_group) => layer_group.has_filter === true
    );
    if (firstLayerGroupWithFilter) {
      setSelectedLayerGroup(firstLayerGroupWithFilter);
    }
  }, [layersGroupsRef]);

  // return <h4>{t("coming_soon")}</h4>;

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <h4>{t("data_filter_control")}</h4>
      {layersGroups.filter((e) => e.has_filter === true).length > 0 ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <Paper style={{ width: "100%" }}>
            <Select
              style={{ width: "100%" }}
              onChange={(e) => {
                e.preventDefault();
                const layerGroupSelected = layersGroups.filter(
                  (layer) => layer.id === e.target.value
                )[0];
                setSelectedLayerGroup(layerGroupSelected);
              }}
              value={selectedLayerGroup ? selectedLayerGroup.id : ""}
            >
              {layersGroups
                .filter((layer) => layer.has_filter === true)
                .map((layerGroup) => (
                  <MenuItem key={layerGroup.id} value={layerGroup.id}>
                    {layerGroup.name[i18n.language]}
                  </MenuItem>
                ))}
            </Select>
          </Paper>
          {/* {selectedLayer && selectedLayer.has_dashboard && <DashboardButton selectedLayer={selectedLayer}/>} */}
          {/* {selectedLayer && selectedLayer.getFilter && <label>{selectedLayer.name}</label>} */}
          {selectedLayerGroup &&
          selectedLayerGroup.layers.filter((e) => e.has_filter === true)
            .length > 0 ? (
            selectedLayerGroup.layers
              .filter((e) => e.has_filter === true && e.getFilter)
              .map((layer) => {
                return (
                  <Paper
                    style={{
                      padding: "0.2rem",
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                    sx={{ backgroundColor: "var(--color-bg-2)" }}
                  >
                    <h3 style={{ paddingLeft: "1rem", paddingRight: "0.5rem" }}>
                      {layer.name[i18n.language]}
                    </h3>
                    {layer.getFilter && layer.getFilter()}
                    <Divider />
                  </Paper>
                );
              })
          ) : (
            <Paper sx={{ padding: "1rem" }}>
              No hay filtros disponibles para este grupo de capas, por favor,
              pruebe otro
            </Paper>
          )}
        </div>
      ) : (
        <Paper sx={{ padding: "1rem" }}>No hay filtros disponibles</Paper>
      )}
    </div>
  );
};

export { LayerFilterSelectorComponent };
